import { red } from '@material-ui/core/colors';
import { createTheme } from '@material-ui/core/styles';
/*
Blue Main  #2270CC
Blue Logo  #49A1CD
Secondary #2ecc71
Purple #4631b2
Green #31b25c
Accent Orange - #FF6E40
Accent Blue - #2296F3
*/

// A custom theme for this app
const theme = createTheme({
   /*
	typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    fontSize: 16,
	},
	*/

   palette: {
      primary: {
         //main: '#2270CC', // Blue Main
         main: '#2270CC',
         light: '#2DA1EF',
         dark: '#1F64AF',
         contrastText: '#fff'
      },
      secondary: {
         //main: '#31b25c',
         main: '#31b25c',

         light: '#2ecc71',
         dark: '#218c74',
         contrastText: '#fff'
      },
      error: {
         main: red.A400
      },
      background: {
         default: '#f6f2ef'
      }
   }
});

export default theme;

// light blue #9ACFFE
